module.exports = __webpack_public_path__ + "static/media/parking_icon.a3cc5f0b.svg";